// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loyalty-block-container[data-v-57ad05c8]{max-width:127rem}h4.ota-p14[data-v-57ad05c8]{max-width:60rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
